import apiClient from './apiClient';

export const spaceService = {
  getSpaces: () => {
    return apiClient.get('/spaces');
  },

  getSpace: (id) => {
    return apiClient.get(`/spaces/${id}`);
  },

  createSpace: (data) => {
    return apiClient.post('/spaces', data);
  },

  updateSpace: (id, data) => {
    return apiClient.put(`/spaces/${id}`, data);
  },

  deleteSpace: (id) => {
    return apiClient.delete(`/spaces/${id}`);
  },
};
